import { render, staticRenderFns } from "./MchPayPassageAddOrEdit.vue?vue&type=template&id=6c42d4ba&scoped=true"
import script from "./MchPayPassageAddOrEdit.vue?vue&type=script&lang=js"
export * from "./MchPayPassageAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./MchPayPassageAddOrEdit.vue?vue&type=style&index=0&id=6c42d4ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c42d4ba",
  null
  
)

export default component.exports